export const GET_THERMOMETERS_LIST_IN_PROGRESS =
  "GET_THERMOMETERS_LIST_IN_PROGRESS";
export const GET_THERMOMETERS_LIST_SUCCESS =
  "GET_THERMOMETERS_LIST_SUCCESS";
export const GET_THERMOMETERS_LIST_FAIL = "GET_THERMOMETERS_LIST_FAIL";
export const GET_THERMOMETER_INFOS_IN_PROGRESS =
  "GET_THERMOMETER_INFOS_IN_PROGRESS";
export const GET_THERMOMETER_INFOS_SUCCESS =
  "GET_THERMOMETER_INFOS_SUCCESS";
export const GET_THERMOMETER_INFOS_FAIL = "GET_THERMOMETER_INFOS_FAIL";
export const POST_THERMOMETER_IN_PROGRESS = "POST_THERMOMETER_IN_PROGRESS";
export const POST_THERMOMETER_SUCCESS = "POST_THERMOMETER_SUCCESS";
export const POST_THERMOMETER_FAIL = "POST_THERMOMETER_FAIL";
export const PUT_THERMOMETER_IN_PROGRESS = "PUT_THERMOMETER_IN_PROGRESS";
export const PUT_THERMOMETER_SUCCESS = "PUT_THERMOMETER_SUCCESS";
export const PUT_THERMOMETER_FAIL = "PUT_THERMOMETER_FAIL";
export const DELETE_THERMOMETER_IN_PROGRESS =
  "DELETE_THERMOMETER_IN_PROGRESS";
export const DELETE_THERMOMETER_SUCCESS = "DELETE_THERMOMETER_SUCCESS";
export const DELETE_THERMOMETER_FAIL = "DELETE_THERMOMETER_FAIL";
